import {literalUnion} from '@raison/io-ts-tools';
import {TypeOf} from 'io-ts';

/**@deprecated don't use this for new code*/
export const BooleanString = literalUnion('true', 'false');
/**@deprecated don't use this for new code*/
export type BooleanString = TypeOf<typeof BooleanString>;
